import { isHttpUrl } from 'app/main/apps/common/fileSource';

/**
 * Opens a PDF in a new tab, from either a link or inlined bytes.
 *
 * PGSS-5476: this only ever handled bytes. Once the packing checklist began sending a signed link
 * instead, atob() was handed an https address and threw, so clicking a PDF did nothing at all --
 * silently, because the failure was inside a click handler.
 *
 * A link needs none of the decoding: the browser can fetch it directly.
 */
const pdfViewerWindow = (source) => {
    if (!source) {
        return;
    }
    if (isHttpUrl(source)) {
        window.open(source, '_blank');
        return;
    }

    const base64PDFData = source.replace(/^data:application\/pdf;base64,/, '');

    // Convert base64 to a blob
    const byteCharacters = atob(base64PDFData);
    const byteArrays = [];
    for (let i = 0; i < byteCharacters.length; i += 1) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }
    const byteArray = new Uint8Array(byteArrays);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create a data URL from the blob
    const dataUrl = URL.createObjectURL(blob);

    // Open a new window or tab with the PDF data URL
    window.open(dataUrl, '_blank');
};

export default pdfViewerWindow
